import Link from 'next/link'
import { useRouter } from 'next/router'
import { motion, cubicBezier } from 'framer-motion'
import { getTranslatedField } from '@/libs/utils'
import type { PersonType } from '@/@types/microcms-type'

type PeopleListProps = {
    people?: PersonType[]
    handleMenu?: () => void
    isOpen?: boolean
}

export const PeopleList = ({ people, handleMenu, isOpen }: PeopleListProps) => {
    const locale = useRouter().locale

    const handleClick = () => {
        handleMenu && handleMenu()
    }

    const ease = cubicBezier(0.25, 0, 0, 1)

    const ulVariants = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        },
        exit: {
            transition: {
                staggerChildren: 0.05
            }
        }
    }

    const liVariants = {
        hidden: { opacity: 0, x: 20 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.8,
                ease: ease
            }
        },
        exit: {
            opacity: 0,
            x: 20,
            transition: {
                duration: 1,
                ease: ease
            }
        }
    }
    return (
        <>
            {people && (
                <motion.ul
                    initial="hidden"
                    animate={isOpen ? 'visible' : 'hidden'}
                    variants={ulVariants}
                    className="grid gap-8 md:gap-10"
                >
                    {people.map(({ id, name, job_title }) => (
                        <motion.li key={id} variants={liVariants}>
                            <Link
                                href={`/people/${id}`}
                                onClick={handleClick}
                                scroll={false}
                                className="grid gap-1 md:hover:opacity-50 duration-[300ms]"
                            >
                                <h2>
                                    {getTranslatedField({
                                        field: name,
                                        locale
                                    })}
                                </h2>
                                <p className="text-sm md:text-lg md:!text-right">
                                    {getTranslatedField({
                                        field: job_title,
                                        locale
                                    })}
                                </p>
                            </Link>
                        </motion.li>
                    ))}
                </motion.ul>
            )}
        </>
    )
}
